export default __webpack_public_path__ + "static/media/loading.a1512ca4.svg";